/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Investor_TitleInputs */

const cs_investor_title = /** @type {(inputs: Investor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investiční profil`)
};

const en_investor_title = /** @type {(inputs: Investor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investor profile`)
};

/**
* | output |
* | --- |
* | "Investor profile" |
*
* @param {Investor_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const investor_title = /** @type {((inputs?: Investor_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Investor_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_investor_title(inputs)
	return cs_investor_title(inputs)
});